// extracted by mini-css-extract-plugin
export var buttonIconWrapper = "_bs-4";
export var collapsed = "_bs-1";
export var headerBar = "_bs-0";
export var leftHeaderContent = "_bs-3";
export var subjectContainer = "_bs-2";